import { css } from "styled-components";

export const basicTextStyle = css`
  color: var(--text-primary);
  background-color: var(--button-primary-default);
  font-weight: var(--font-weight-regular);
  border: 1px solid var(--button-primary-default) !important;

  svg:not([data-icon="loading"]) path {
    stroke: var(--icon-default) !important;
  }

  &:hover {
    background-color: var(--button-text-hover) !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--button-text-hover) !important;

    svg:not([data-icon="loading"]) path {
      stroke: var(--icon-default) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--text-primary) !important;
    background-color: var(--button-primary-default) !important;
    border: 1px solid var(--button-primary-default) !important;

    svg:not([data-icon="loading"]) path {
      stroke: var(--icon-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-focused-shadow) !important;
    box-shadow: 0 0 0 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-text-clicked) !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--button-text-clicked) !important;

    svg:not([data-icon="loading"]) path {
      stroke: var(--icon-default) !important;
    }
  }

  &[disabled] {
    color: var(--text-primary);
    background-color: var(--button-primary-default);
    border: 1px solid var(--button-primary-default) !important;
    opacity: 0.5;

    &:hover {
      color: var(--text-primary);
      background-color: var(--button-primary-default);
      border: 1px solid var(--button-primary-default) !important;
      opacity: 0.5;
    }
  }
`;
